export const environment = {
  production: false,

  // SAT backend base URLs
  apiUrl: "https://sat-dev.allianz.com.my/sat-common-svc/api/v1",
  sessionApiUrl: "https://sat-dev.allianz.com.my/sat-motor-svc/v1",
  commonApiUrl: "https://alpha-dev.allianz.com.my/alpha-modular-svc/common",
  alphaSatApiUrl: "https://alpha-dev.allianz.com.my/alpha-sat-svc",

  // Local mock-server base URLs
  mockServerApiEnabled: false,

  // Temporary rollout switch while summary/notification APIs are still being
  // integrated behind the new login flow in DEV.
  tolerateIncompleteSummaryBootstrapAuthFailures: true,
  authRefreshBufferMs: 30000,
  passwordMinLength: 8,

  // Cross-app targets
  alpha_url: "https://alpha-dev.allianz.com.my/alpha-web/autoLogin.zul?token=",
  alpha_sat_url: "https://alpha-dev.allianz.com.my/alpha-sat",

  // Analytics
  gtagId: "G-GBN1YT4BWR",

  // Feature flags
  policyManagementDebugMode: false,
};
